var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorContent"},[_c('img',{attrs:{"src":require("../../assets/img/404@2x.png")}}),_c('p',[_vm._v("啊哦～这个页面走丢了...")]),_c('p',[_vm._v("我们正尝试与TA联系，您可以")]),_c('router-link',{attrs:{"to":"/","tag":"a"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }